import React from 'react'
import { Flex, Input as Base, Textarea } from 'rebass'
import startCase from 'lodash.startcase'

import PhoneInput from './PhoneInput'
import Text from './Text'
import Label from './Label'

export const Input = Base.extend`
  border-radius: ${props => props.theme.radii[2]}px;
  transition: all 100ms linear;
  
  &+label {
    color:${props => props.theme.colors.text};
  }
    
  &:disabled+label{
    color:${props => props.theme.colors.disabled};
  }
`

const TextField = ({hideLabel, label, required, hideError, phone, textArea, forwardedRef, field, form: {touched, errors, isSubmitting, setFieldValue}, ...others}) =>
  <Flex flexDirection='column-reverse' justifyContent='flex-end' mb={2}>
    {!hideError && touched[field.name] && errors[field.name] && <Text error f={1} ml={2}>{errors[field.name]}</Text>}
    {phone
      ? <PhoneInput mb={1} readOnly={isSubmitting} setFieldValue={setFieldValue} {...field} {...others} />
      : textArea
        ? <Textarea mb={1} readOnly={isSubmitting} {...field} {...others} />
        : <Input mb={1} readOnly={isSubmitting} {...field} {...others} />
    }
    {hideLabel
      ? <Label>&nbsp;</Label>
      : <Label>{label || startCase(field.name)}{required && ' *'}</Label>}
  </Flex>

export default TextField


// WEBPACK FOOTER //
// ./src/components/TextField.js